import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const PortalModal = ({ children, isOpen }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);

    if (!isOpen || !mounted) return null;

    return ReactDOM.createPortal(
        children,
        document.getElementById('modal-root')
    );
};

export default PortalModal;